document.addEventListener("DOMContentLoaded", function () {

  // Use event delegation to handle dynamically injected sections
  document.addEventListener("click", function(e) {

    // Only run if the click is on a tab
    const tab = e.target.closest("ul.shopify-tabs > li");
    if (!tab) return;

    e.preventDefault();

    const tab_id = tab.getAttribute("data-tab");

    // Remove active classes
    document.querySelectorAll("ul.shopify-tabs > li").forEach((li) => {
      li.classList.remove("current");
    });

    document.querySelectorAll(".shopify-tab-content").forEach((content) => {
      content.classList.remove("current");
    });

    // Add active class to selected tab + content
    tab.classList.add("current");
    document.getElementById(tab_id)?.classList.add("current");
  });

});
